module.exports = __webpack_public_path__ + "img/logo.c445f5ea.png";